import { render, staticRenderFns } from "./sliderList.vue?vue&type=template&id=687c8e90&scoped=true&"
import script from "./sliderList.vue?vue&type=script&lang=js&"
export * from "./sliderList.vue?vue&type=script&lang=js&"
import style0 from "./sliderList.vue?vue&type=style&index=0&id=687c8e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687c8e90",
  null
  
)

export default component.exports